import styled from "styled-components";

export const LimitsExceededContent = styled.div`
  width: 100%;
`;

export const RatioLinesContainer = styled.div`
  margin: 1.5rem 0;
`;
